// extracted by mini-css-extract-plugin
export default {"categorySelector":"TabsSelector_categorySelector","item":"TabsSelector_item","selected":"TabsSelector_selected"};